import React, { Component } from 'react';
import './_styles.scss'
import Translator from '../../../../../requests/apa/Translator';
import Utils from '../../../../../utils/Utils';
import { getMatchTimeLabel } from '../../../utils';
import { matchInProgress, matchCompleted } from '../../../constants';

class Tag extends Component {
    constructor(props) {
        super(props)
    }

    getTagLiveEvent = () => {
        const label = Translator.get('tag_envivo');

        if(label !== 'tag_envivo') return label;

        return Translator.get('Tag_EnVivo');
    }
    
    render() {
        const { matchProgress, broadcast, status, time, timezone, scheduledAt } = this.props

        const isLiveOrFinished = status === matchInProgress || status === matchCompleted
        const hasScheduledAt = typeof scheduledAt === 'string' && scheduledAt.trim().length > 0;

        const isLiveWithBroadcast = broadcast && broadcast.isAvailable && status === matchInProgress

        if (isLiveWithBroadcast) {
            return (
                <div className='tag-container'>
                    <div className="live-tag">
                        {Utils.cutPlayerString(this.getTagLiveEvent(), 7)}
                    </div>
                    {
                        matchProgress && matchProgress.minute 
                        ? <div className='minute-container'>{`${matchProgress.minute}'`}</div>
                        : null
                    }
                </div>
            )
        }

        return <span>{getMatchTimeLabel(status, time, timezone, scheduledAt, matchProgress && matchProgress.minute ? matchProgress.minute : undefined)}</span>
    }
}

export default Tag


// WEBPACK FOOTER //
// ./src/containers/Mundial2026/Partidos/Components/Tag/Tag.jsx